import { constants } from '@bedc/constants';

import { Request as BaseRequest } from '../../../../generic/search/Request';

export const Request = BaseRequest({
	sortFields: constants.user.preferences.uiSettingsTemplate.sortFields,
	columnFields: constants.user.preferences.uiSettingsTemplate.columnFields,
	standardFilterFields: constants.user.preferences.uiSettingsTemplate.filterFields,
	dateFilterFields: [] as const,
	stageStatusFilterFields: [] as const,
	booleanFilterFields: [] as const,
});
